import type { ClientContext } from '~/services/contextClient';
import { analyticsClientConfig } from '~/services/analytics/analyticsClient.types';
import CorporateWorkflowAnalyticsClient from './corporateWorkflowAnalyticsClient';
import type { WorkflowAnalyticsClientInterface } from './workflowAnalyticsClient.types';

export default class WorkflowAnalyticsClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId' | 'orgUnitId'>): WorkflowAnalyticsClientInterface {
        return new CorporateWorkflowAnalyticsClient(context.teamId, analyticsClientConfig);
    }
}
